module.exports = __webpack_public_path__ + "img/uj_06.8903009b.jpg";